import invoiceModule from '../module'
import goodsDialogPage from '../view/goodsDialog.html'

class ModalListCtrl {
    constructor($scope, invoiceModalData, $uibModalInstance) {
        $scope.invoice = invoiceModalData.invoice
        $scope.selectedRows = invoiceModalData.selectedRows
        $scope.cancel = function cancel() {
            $uibModalInstance.dismiss()
        }
        $scope.ok = function ok() {
            $uibModalInstance.close()
        }
    }
}
ModalListCtrl.$inject = ['$scope', 'invoiceModalData', '$uibModalInstance']

invoiceModule.controller('goodsAddmodalCtrl', ModalListCtrl)
invoiceModule.directive('goodsAdd', () => ({
    scope: {
        invoice: '<',
        selectedRows: '<',
        cannotList: '@', // 某些票不能清单
        isRed: '@',
    },
    restrict: 'E',
    replace: false,
    template: `
        <button class="btn btn-primary btn-xs jia" ng-click="addGoods()">
            <i class="iconfont icon-jiahangmoren1"></i>
        </button>
    `,
    controller: ['$scope', '$uibModal', 'logger', function ctrl($scope, $uibModal, logger) {
        $scope.addGoods = function addGoods() {
            const { invoice } = $scope
            if (invoice.isRed === '1' && invoice.details.length === invoice.getMaxRow() && invoice.invType != '41' ) {
                logger.logError('商品明细行最多8行')
                return
            }
            if (invoice.invType === '41' && invoice.details.length + 1 > invoice.limitNumber) {
                logger.logError(`增值税普通发票（卷票）最大允许${invoice.limitNumber}行商品明细`)
                return
            }
            function call() {
                const len = $scope.invoice.details.length
                if (len > $scope.invoice.step) {
                    const pages = parseInt(len / $scope.invoice.step)
                    if (len % $scope.invoice.step > 0 && len % $scope.invoice.step < 11) {
                        $scope.invoice.min = pages * $scope.invoice.step - $scope.invoice.step - 1
                        $scope.invoice.max = pages * $scope.invoice.step + len % $scope.invoice.step
                    } else if (len % $scope.invoice.step > 10) {
                        $scope.invoice.min = pages * $scope.invoice.step - 1
                        $scope.invoice.max = len
                    } else if (len % $scope.invoice.step == 0) {
                        $scope.invoice.min = len - $scope.invoice.step - 1
                        $scope.invoice.max = len
                    }
                }
                $('.slimScrollBar').css({ bottom: 0.5 })
            }
            $scope.invoice.addGoods(call)
            $scope.openDialog()
        }
        $scope.$on('openGoodsDialog', (e) => {
            $scope.openDialog()
        })

        $scope.openDialog = function openDialog() {
            if ($scope.invoice.details.length <= $scope.invoice.getMaxRow() || $scope.cannotList) {
                return
            }
            $uibModal.open({ // 第一个弹框
                template: goodsDialogPage,
                controller: 'goodsAddmodalCtrl',
                openedClass: 'mod-modal-haslist mod-modal mod-modal-lg',
                windowClass: 'goods-detail-modal',
                backdrop: 'static',
                resolve: {
                    invoiceModalData() {
                        return {
                            invoice: $scope.invoice,
                            selectedRows: $scope.selectedRows,
                        }
                    },
                },
            }).result.then(() => {
                if ($scope.invoice.details.length > $scope.invoice.getMaxRow()) {
                    $scope.invoice.isList = '1'
                } else {
                    $scope.invoice.isList = '0'
                }
            })
        }
    }],
}))



// WEBPACK FOOTER //
// ./src/app/outputManage/fillOpenManage/invoice1/components/goodsAdd.js